import { motion } from "framer-motion";

const CAT_IMAGES = {
  sparklers: "/images/products/sparkler-gold.jpeg",
  flowerpots: "/images/products/flowerpot-deluxe.jpeg",
  chakkar: "/images/products/chakkar-deluxe.jpeg",
  rockets: "/images/products/rocket-classic.jpeg",
  bombs: "/images/products/garland-ladi.jpeg",
  fancy: "/images/products/aerial-shots.jpeg",
  kids: "/images/products/kids-pencil.jpeg",
};

export default function Categories({ categories, active, onPick }) {
  return (
    <section id="categories" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="flex flex-wrap items-end justify-between gap-4"
        >
          <div>
            <p className="font-mono text-[11px] tracking-[0.34em] uppercase text-ember">Seven families of fire</p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-starlight">
              Shop by Category
            </h2>
          </div>
          <p className="font-editorial italic text-muted-night text-lg">One sparkle for every celebration.</p>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 sm:gap-4">
          {categories.map((cat, i) => (
            <motion.button
              key={cat.slug}
              data-testid={`category-card-${cat.slug}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.07 }}
              onClick={() => onPick(cat.slug)}
              className={`group rounded-2xl border p-4 text-left transition-all duration-300 hover:-translate-y-1 ${
                active === cat.slug
                  ? "border-ember/80 bg-card-hover ember-glow"
                  : "border-starlight/10 bg-card hover:border-ember/50"
              }`}
            >
              <img
                src={CAT_IMAGES[cat.slug]}
                alt={cat.label}
                loading="lazy"
                className="h-16 w-16 rounded-full object-cover border border-ember/25 group-hover:scale-105 transition-transform duration-500"
              />
              <p className="mt-4 font-semibold text-starlight text-sm sm:text-base leading-tight">{cat.label}</p>
              <p className="font-mono text-[10px] tracking-[0.14em] text-muted-night mt-1">{cat.tamil}</p>
              <p className="mt-2 font-mono text-[10px] text-ember/80">{cat.count} items</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
